/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerEntityDocumentTypeEnum;

(function (BrokerEntityDocumentTypeEnum) {
  BrokerEntityDocumentTypeEnum["GENERAL"] = "general";
  BrokerEntityDocumentTypeEnum["TOBA_SIGNED"] = "toba_signed";
  BrokerEntityDocumentTypeEnum["TOBA_UNSIGNED"] = "toba_unsigned";
})(BrokerEntityDocumentTypeEnum || (BrokerEntityDocumentTypeEnum = {}));